import { FieldProps } from 'formik'
import { FormikToggle } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { Proving } from 'model'
import { Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export interface ProvingDetailsSpecialUsageValues {
  bySaturday: boolean
  bySunday: boolean
  byNight: boolean
}

export const ProvingDetailsSpecialUsageForm: React.FC<{ proving: Proving }> = ({
  proving,
}) => {
  const { t } = useTranslation()

  return (
    <FormStack>
      <FieldStack>
        <Label>{t('field.specialUsage.bySaturday')}</Label>
        <FieldStackItem
          name="specialUsage.bySaturday"
          render={(
            fieldProps: FieldProps<ProvingDetailsSpecialUsageValues>
          ) => {
            return <FormikToggle {...fieldProps} />
          }}
        />
      </FieldStack>
      <FieldStack>
        <Label>{t('field.specialUsage.bySunday')}</Label>
        <FieldStackItem
          name="specialUsage.bySunday"
          render={(
            fieldProps: FieldProps<ProvingDetailsSpecialUsageValues>
          ) => {
            return <FormikToggle {...fieldProps} />
          }}
        />
      </FieldStack>
      <FieldStack>
        <Label>{t('field.specialUsage.byNight')}</Label>
        <FieldStackItem
          name="specialUsage.byNight"
          render={(
            fieldProps: FieldProps<ProvingDetailsSpecialUsageValues>
          ) => {
            return <FormikToggle {...fieldProps} />
          }}
        />
      </FieldStack>
    </FormStack>
  )
}
